import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
$(document).ready(function () {
    var cookies = {
        fr: {
            locale: "fr",
            content: {
                link: "/politique-de-cookies/",
                banner: {
                    title: "En utilisant ce site, vous acceptez l'utilisation des cookies."
                },
                popup: {
                    title: "Ce site utilise des cookies.",
                    description: "Ce site utilise des cookies. Nous utilisons des cookies pour que notre site web fonctionne au mieux, améliorant ainsi votre expérience en ligne. Afin d’en savoir plus sur l’utilisation des cookies, les plug-ins pour les réseaux sociaux ainsi que le web tracking, n’hésitez pas à consulter notre page d’informations sur les Cookies ainsi que notre Déclaration de Protection des Données."
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Cookies nécessaires",
                    description: "Les cookies nécessaires aident à rendre un site Web utilisable en activant de base \
                    des fonctions telles que la navigation sur les pages et l'accès aux zones sécurisées du site Web. Le site Web ne peut pas \
                    fonctionner correctement sans ces cookies.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "cookieconsent.extension",
                            purpose: "Stocke l'état de consentement des cookies de l'utilisateur pour le domaine actuel",
                            expiry: "1 an",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: false,
                    title: "Analytics Cookies",
                    "function": function () {
                        activateTracking();
                    },
                    description: "Les cookies analytiques aident les propriétaires de sites Web à comprendre comment les visiteurs \
                    interagir avec les sites Web en collectant et en signalant des informations de manière anonyme.",
                    cookies: [
                        {
                            name: "_dc_gtm_UA-#",
                            provider: "Google Tag Manager",
                            purpose: "Utilisé pour charger Google Analytics.",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "2 ans",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Utilisé par Google Analytics pour réduire le taux de demandes",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "1 jour",
                            type: "HTTP"
                        }
                    ]
                },
                some: {
                    name: "some",
                    value: false,
                    title: "Cookies 'Réseaux sociaux'",
                    "function": function () {
                        activateMarketing();
                    },
                    description: "Ces cookies sont activés par les services proposés sur les réseaux sociaux que nous avons ajoutés au site Web afin de vous donner la possibilité de partager notre contenu avec votre réseau et vos connaissances. Ils nous permettent également de suivre votre navigation sur d’autres sites Web et d’établir un profil de vos intérêts. Cela peut avoir un impact sur le contenu et les messages affichés sur les autres sites Web que vous consultez. Si vous n'autorisez pas ces cookies, il se peut que vous ne puissiez pas utiliser ou visualiser ces outils de partage.",
                    cookies: [
                        {
                            name: "_fbp",
                            provider: "Facebook",
                            purpose: " Utilisé par Facebook pour fournir une série de produits publicitaires, tels que des offres en temps réel d'annonceurs externes",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                    ]
                }
            }
        }
    };
    var CookieConsentNode = new CookieConsent(cookies.fr);
    CookieConsentNode.init();
    var viewCookieBannerButton = document.querySelector(".cookies.Button");
    if ($(".cookies.Button").length) {
        viewCookieBannerButton.addEventListener("click", function (e) {
            e.preventDefault();
            CookieConsentNode.showDetails();
        });
    }
});
